<template>
  <div class="app-content">
    <ComList
      ref="appMgtRef"
      :dataPro="dataPro"
      :formItem="formItem"
      :buttonItem="buttonItem"
      :tableItem="tableItem"
      :showTenant="false"
      v-model:multipleSelection="multipleSelection"
    >
      <template #defineButton>
        <div style="display: flex">
          <span
            style="
              display: flex;
              align-items: center;
              margin-right: 10px;
              font-size: 12px;
            "
          >
            <b style="color: red">注</b>
            ：【同步状态】标识该应用是否同步至云机应用市场，【应用状态】标识该应用是否在云机应用市场上架</span
          >
          <el-button type="primary" size="small" @click="installRecords"
            >安装记录</el-button
          >
           <el-button type="success" size="small" @click="setCategory"
            >分类管理</el-button
          >
        </div>
      </template>
    </ComList>
    <addFile ref="addFileRef" @freshList="reloadList" />
    <installAppToDevice ref="installAppToDeviceRef" />
    <installRecordsComp ref="installRecordsRef" />
    <categoryMgt ref="categoryMgtRef" />
    <setCategoryComp ref="setCategoryRef" @success="reloadList" />
  </div>
</template>
<script setup>
import { ref } from "vue";
import ComList from "@/components/comList/index.vue";
import addFile from "./components/addApp.vue";
import request from "@/utils/request.ts";
import API_CONFIG from "./api.json";
import { ElMessage } from "element-plus";
import installAppToDevice from "./components/installAppToDevice.vue";
import installRecordsComp from "./components/installRecords.vue";
import categoryMgt from "./components/categoryMgt.vue";
import setCategoryComp from "./components/setCategory.vue";

const appMgtRef = ref(null);
const addFileRef = ref(null);
const installAppToDeviceRef = ref(null);
const installRecordsRef = ref(null);
const categoryMgtRef = ref(null); 
const setCategoryRef = ref(null);
const multipleSelection = ref([]);
const buttonItem = ref([
  {
    label: "新增应用",
    type: "add",
    click: () => {
      addFileRef.value.open();
    },
  },
  {
    label: "安装",
    type: "custom",
    click: () => {
      if (multipleSelection.value.length == 0) {
        ElMessage.warning("请先选择应用");
        return;
      }
      installAppToDeviceRef.value.open(multipleSelection.value);
    },
  },
  {
    label: "批量同步",
    type: "custom",
    click: () => {
      if (multipleSelection.value.length == 0) {
        ElMessage.warning("请先选择应用");
        return;
      }
      // 校验选择的应用是否都未同步
      const isSync = multipleSelection.value.every(ele => ele.syncStatus == 0);
      if (!isSync) {
        ElMessage.warning("请选择未同步的应用");
        return;
      }
      const data =multipleSelection.value.map(ele=>{
        return {
          appName: ele.appName,
          packageName: ele.packageName,
          fileMd5: ele.fileMd5,
          version: ele.version,
        }
      })
      syncApp(data);
    },
  },
  {
    label: "设置分类",
    type: "custom",
    click: () => {
      if (multipleSelection.value.length == 0) {
        ElMessage.warning("请先选择应用");
        return;
      }
      setCategoryRef.value.open(multipleSelection.value);
    },
  },
]);
const syncStatusOptions = ref([
  {
    label: "未同步",
    value: 0,
  },
  {
    label: "已同步",
    value: 1,
  },
  {
    label: "同步中",
    value: 2,
  },
  {
    label: "同步失败",
    value: 3,
  },
]);
const formItem = ref([
  { label: "应用名称", prop: "appName", width: 100, type: "input" },
  { label: "包名", prop: "packageName", width: 100, type: "input" },
  { label: "文件md5", prop: "fileMd5", width: 100, type: "input" },
  {
    label: "同步状态",
    prop: "syncStatus",
    width: 100,
    type: "select",
    optionsPro: async () => await Promise.resolve(syncStatusOptions.value),
  },
  {
    label: "应用状态",
    prop: "status",
    width: 100,
    type: "select",
    optionsPro: async () =>
      await Promise.resolve([
        {
          label: "已上架",
          value: 0,
        },
        {
          label: "已下架",
          value: 1,
        },
      ]),
  },
  // { label: "创建时间", prop: "createTime", width: 100, type: "daterange", startPlaceholder:'开始时间',endPlaceholder:'结束时间' },
]);

const tableItem = ref([
  {
    label: "Logo",
    prop: "logo",
    width: 100,
    cellRenderer: ({ value }) => {
      return `<div style="width:100%;"><img src='${value}' style="width:20px;"/></div>`;
    },
  },
  { label: "应用名称", prop: "appName" },
  { label: "包名", prop: "packageName", width: 300 },
  { label: "分类", prop: "tags", valueFormatter: (
    { value }) => {
    return value.map(tag=>tag.tagName).join("、") }},
  { label: "版本号", prop: "version" },
  { label: "文件MD5", prop: "fileMd5", width: 400 },
  {
    label: "文件大小",
    prop: "fileSize",
    valueFormatter: ({ value }) => {
      if (value < 1024 * 1024) {
        return (value / 1024).toFixed(2) + " KB";
      } else if (value < 1024 * 1024 * 1024) {
        return (value / 1024 / 1024).toFixed(2) + " MB";
      } else {
        return (value / 1024 / 1024 / 1024).toFixed(2) + " GB";
      }
    },
  },
  {
    label: "应用状态",
    prop: "status",
    valueFormatter: ({ value }) => {
      return value == 0 ? "已上架" : "已下架";
    },
    cellStyle: ({ value }) => ({
      color: value == 0 ? "green" : "gray",
    }),
  },
  {
    label: "同步状态",
    prop: "syncStatus",
    valueFormatter: ({ value }) => {
      return (
        syncStatusOptions.value.find((item) => item.value == value)?.label || ""
      );
    },
    cellStyle: ({ value }) => ({
      color:
        value == 0
          ? "gray"
          : value == 1
          ? "green"
          : value == 2
          ? "orange"
          : "red",
    }),
  },
  { label: "创建时间", prop: "createTime" },
  {
    label: "操作",
    prop: "",
    type: "custom",
    width: 200,
    fixed: "right",
    opeList: [
        {
        label: "设置分类",
        onClick: (row) => {
          setCategoryRef.value.open([row]);
        },
      },
      {
        label: "安装",
        onClick: (row) => {
          installAppToDeviceRef.value.open([row]);
        },
      },
      {
        label: "同步",
        show: (row) => row.syncStatus == 0,
        onClick: (row) => {
          const { appName, packageName, fileMd5, version } = row;
          syncApp([{ appName, packageName, fileMd5, version }]);
        },
      },
      {
        label: "上架",
        show: (row) => row.syncStatus == 1 && row.status == 1,
        onClick: (row) => {
          updateOnlineStatus(row.fileMd5, true);
        },
      },
      {
        show: (row) => row.syncStatus == 1 && row.status == 0,
        label: "下架",
        color: "red",
        onClick: (row) => {
          updateOnlineStatus(row.fileMd5, false);
        },
      },
      {
        show: (row) => row.syncStatus == 1 && row.status == 1,
        label: "取消同步",
        color: "red",
        onClick: (row) => {
          request.post(API_CONFIG.deleteApp.url + "/" + row.id).then((res) => {
            if (res.code == 200 && res.data) {
              ElMessage.success("取消同步成功");
              reloadList();
            } else {
              ElMessage.error("取消同步失败");
            }
          });
        },
      },
      {
        label: "删除",
        type: "delete",
        show: (row) => row.syncStatus == 0,
        onClick: (row) => {
           deleteApp([row.id]);
        },
        color: "red",
      },
    ],
  },
]);

const updateOnlineStatus = (fileMd5, status) => {
  request
    .post(API_CONFIG.updateOnlineStatus.url, {
      md5List:[fileMd5],
      onlineFlag: status,
    })
    .then((res) => {
      if (res.code == 200) {
        ElMessage.success(status ? "上架成功" : "下架成功");
        reloadList();
      } else {
        ElMessage.error(status ? "上架失败" : "下架失败");
      }
    });
};

// 同步应用到应用商店
const syncApp = (apps) => {
  request
    .post(API_CONFIG.syncAppToMarket.url, {
      apps,
    })
    .then((res) => {
      if (res.code == 200 && res.data) {
        ElMessage.success("同步成功");
        reloadList();
      } else {
        ElMessage.error("同步失败");
      }
    });
};

// 删除云盘应用
const deleteApp = (ids) => {
  request.delete(API_CONFIG.batchDeleteApp.url, { data: ids }).then((res) => {
    if (res.code == 200) {
      ElMessage.success("删除成功");
      reloadList();
    } else {
      ElMessage.error(res.msg);
    }
  });
};

const dataPro = API_CONFIG.queryUrl.url;
const reloadList = () => {
  appMgtRef.value.searchFun();
};

const installRecords = () => {
  installRecordsRef.value.open();
};

const setCategory = () => {
  categoryMgtRef.value.open();
}
</script>
<style scoped lang="scss">
.app-content {
  height: 100vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
</style>
